module.exports = __webpack_public_path__ + "img/sup_deposit_bank_1.b92b4945.png";